import { useQuery } from '@tanstack/react-query';

import { Project } from './projects.types';
import { TypesenseCollection } from '../types';
import { getProjectById } from './projects';
import { useGetTypeSenseAPIKeys } from '@/api/REST/typeSenseAPIKeys';

const PROJECT_BY_ID_KEY = 'projectById';

/**
 * Fetches a complete project document by SourceId from Typesense
 * Returns the full project document with all fields, not just select option fields
 */
export const useGetProjectById = (sourceId: string | null | undefined) => {
  const { data: apiKeys } = useGetTypeSenseAPIKeys();
  const collectionApiKey =
    apiKeys?.[TypesenseCollection.PROJECTS.keyName]?.key ?? null;

  const { data, ...restProps } = useQuery<Project | null>({
    queryKey: [PROJECT_BY_ID_KEY, sourceId, collectionApiKey],
    queryFn: () => getProjectById(sourceId, collectionApiKey),
    enabled: !!sourceId && !!collectionApiKey,
  });

  return { data, ...restProps };
};
